import React from 'react';
import { useLightbox } from '@/hooks/useLightbox';
import { AdvancedMediaLightbox } from './advanced-media-lightbox';

export function GlobalLightbox() {
  const { isOpen, lightboxData, closeLightbox } = useLightbox();

  if (!isOpen || !lightboxData) return null;

  return (
    <AdvancedMediaLightbox
      isOpen={isOpen}
      onClose={closeLightbox}
      media={lightboxData.media}
      initialIndex={lightboxData.initialIndex}
      backgroundAudioUrl={lightboxData.backgroundAudioUrl}
      autoPlayBackgroundAudio={lightboxData.autoPlayBackgroundAudio}
      postId={lightboxData.postId}
      authorId={lightboxData.authorId}
      authorName={lightboxData.authorName}
      authorPhoto={lightboxData.authorPhoto}
      createdAt={lightboxData.createdAt}
      content={lightboxData.content}
      location={lightboxData.location}
      taggedUsers={lightboxData.taggedUsers}
      reactions={lightboxData.reactions}
      comments={lightboxData.comments}
      onReactionAdd={lightboxData.onReactionAdd}
      onCommentAdd={lightboxData.onCommentAdd}
      onLocationAdd={lightboxData.onLocationAdd}
      onTagUser={lightboxData.onTagUser}
      onUpdate={lightboxData.onUpdate}
    />
  );
}
